import {createSlice}  from "@reduxjs/toolkit";
import { STORE_VIDEO_REDUCER } from "../../../constants/reducer_names";



const initialState = {

    participantList: [],
    midValue: 2,
    callStatus: "Waiting",
    socketData: [],
    iswaiting: false,
    activeSpeaker: [],
    videoResolution: 640,
    currentBandwidth: 1000
}

const storeVideoSlice : any  = createSlice({
name: STORE_VIDEO_REDUCER,
initialState,
reducers : {
    participantVideoInfo:(state,{ payload}) => {
        state.participantList = payload.participantList;
        state.midValue = payload.midValue;
        state.callStatus = payload.callStatus;
    },
    callStatus:(state,{payload}) =>{
        state.callStatus =payload.callStatus;
    },
    callWaitingStatus : (state,{ payload }) =>{
        state.iswaiting = payload.iswaiting;
    },
    callSyncStore : (state, {payload}) => {
         state.socketData = payload.socketData;
    },
     activeSpeaker : (state,{payload}) =>{
        state.activeSpeaker = payload.activeSpeaker;
     },
     videoResolution :(state, {payload}) => {
        state.videoResolution = payload.videoResolution;
     },
     currentBandwidth : (state, {payload}) =>{
        state.currentBandwidth = payload.currentBandwidth;
     },

     reset: () => {},
},

});

export const storeVideoSliceAction = storeVideoSlice.actions;
export default storeVideoSlice.reducer;